import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pop } from 'src/app/classes/shared/pop';
import { TrackerService } from 'src/app/services/api/trackers/tracker.service';
import { ButtonComponent, ChipComponent } from 'ui-library';

@Component({
  selector: 'app-set-config-modal',
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    ButtonComponent,
    MatToolbarModule,
    ChipComponent
  ],
  standalone: true,
  templateUrl: './set-config-modal.component.html',
  styleUrls: ['./set-config-modal.component.scss']
})

export class SetConfigModalComponent implements OnDestroy {
  trackers: any[] = [];
  configs: any[] = [];
  configId: string = "";
  projectId: string = "";
  destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SetConfigModalComponent>,
    private tools: Pop,
    private trackerService: TrackerService
  ) {
    this.trackers = this.data.trackers;
    this.getConfigs();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getConfigs() {
    this.trackerService.getConfigs().pipe(takeUntil(this.destroy$)).subscribe((res: any[]) => {
      this.configs = res;
    })
  }

  setConfig() {
    if (this.configId) {
      this.trackerService.setTrackersConfig(this.trackers.map(t => t.uuid), this.configId).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.dialogRef.close();
      }, (err: string) => {
        console.error(err);
        this.tools.error("Config error");
      })
    }
  }

}

